import {
  AssignmentLesson,
  NotesLesson,
  QuizV2Lesson,
  TestLesson,
  VideoLesson,
} from '@/interfaces/lectureTrack';

export function isVideoLesson(data: any): data is VideoLesson {
  return data?.type === 'video';
}

export function isAssignment(data: any): data is AssignmentLesson {
  return data?.type === 'assignment_v2';
}

export function isNotesLesson(data: any): data is NotesLesson {
  return data?.type === 'notes';
}
export function isPartnerExam(data: any): data is NotesLesson {
  return data?.type === 'partner_exam';
}

/* isLectureIsLocked  will accept the date, 
and based on the date it check the event is locked or unlocked, 
if locked show locked Ui else show the lecture 
NOTE: this is different from the status locked or unlocked.
      - if status is locked we are not showing it to the user,
      - if status is unlocked, we check is its a past event or upcoming event,
              a. if past, show lecture video or notes
              b. if upcoming show locked content UI 

*/

export function isLectureIsLocked(date: any) {
  // Convert the given date string to a Date object
  const eventDate = new Date(date);

  // Get the current date and time as a Date object
  const currentDate = new Date();

  // Compare the two date objects
  if (eventDate > currentDate) {
    // The event is in the future
    return true;
  }
  // The event has already occurred (past event)
  return false;
}

export function isLectureLive(lessonDetails: VideoLesson) {
  const { lectureMode } = lessonDetails;
  if (lectureMode === 'live') return true;
  return false;
}

export function isLectureLiveIsCompleted(lessonDetails: VideoLesson) {
  const { isLiveClassCompleted } = lessonDetails;
  if (isLiveClassCompleted) return true;
  return false;
}

export function isLectureUpcoming(startDate: any, currentTime: any) {
  // Convert the given date string to a Date object
  const eventDate = new Date(startDate);

  // Get the current date and time as a Date object
  const currentDate = currentTime ? new Date(currentTime) : new Date();

  // Compare the two date objects
  if (eventDate > currentDate) {
    // The event is in the future
    return true;
  }
  // The event has already occurred (past event)
  return false;
}

// status locked and unlocked
export function isLectureStatusLocked(data: any): data is NotesLesson {
  if (data?.status === 'locked') return true;
  return false;
}

// is lesson test or quiz
export const isLessonTestOrQuiz = (data?: TestLesson | QuizV2Lesson) => {
  return data?.type === 'test' || data?.type === 'quiz_v2';
};

// is lesson test or quiz currently live
export const isLiveTestOrAssignmentLive = (data?: TestLesson | AssignmentLesson) => {
  // Convert the given date string to a Date object
  const eventStartDate = new Date(data?.startDate);
  const eventEndDate =
    data?.type === 'test' ? new Date(data?.endDate) : new Date(data?.assignmentV2?.expiryDate);

  // Get the current date and time as a Date object
  const currentDate = new Date();

  // Compare the two date objects
  if (eventStartDate < currentDate && eventEndDate > currentDate) {
    // The event is in the future
    return true;
  }
  // The event has already occurred (past event)
  return false;
};

// is lesson test or quiz
export const isLiveTestOrAssignmentCompleted = (data?: TestLesson | AssignmentLesson) => {
  // Convert the given date string to a Date object
  const eventEndDate = new Date(data?.endDate);

  // Get the current date and time as a Date object
  const currentDate = new Date();

  // Compare the two date objects
  if (eventEndDate < currentDate) {
    // The event is in the future
    return true;
  }
  // The event has already occurred (past event)
  return false;
};

export const getLectureType = (lecture: string) => {
  let lectureType;

  switch (lecture) {
    case 'video':
      lectureType = 'Lecture';
      break;
    case 'notes':
      lectureType = 'Lesson';
      break;
    case 'assignment_v2':
      lectureType = 'Assignment';
      break;
    default:
      lectureType = 'Lecture';
      break;
  }

  return lectureType;
};

export const destructureSlug = (slug: string) => slug?.replace(/-/g, ' ');

export const buildPowerBatchRedirectPath = (targetUrl?: string): string | null => {
  if (!targetUrl) {
    return null;
  }
  const match = targetUrl.match(/pw-live-class\/([^/?#]+)/i);
  if (match?.[1]) {
    return `/classroom/pw-live-class/${match[1]}`;
  }
  const sanitized = targetUrl.split('?')[0].replace(/#.*$/, '');
  const segments = sanitized.split('/').filter(Boolean);
  const classId = segments.pop();
  return classId ? `/classroom/pw-live-class/${classId}` : null;
};
